// (function () {
//   // Only run for Designer customers
//   function isDesigner() {
//     return !!(window.__B2B__ && window.__B2B__.isDesigner);
//   }

//   // Parse "$4,399.20" -> 4399.2
//   function parseMoney(text) {
//     return Number((text || "").replace(/,/g, "").replace(/[^0-9.]/g, ""));
//   }

//   // Format number like "$4,401" (NO decimals, to match your theme rounding behavior)
//   function formatMoneyNoDecimals(originalText, number) {
//     const symbolMatch = (originalText || "").match(/[^0-9.,\s]+/);
//     const symbol = symbolMatch ? symbolMatch[0] : "$";

//     const whole = String(Math.round(Number(number) || 0));
//     const withThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//     return symbol + withThousands;
//   }

//   function apply() {
//     if (!isDesigner()) return;

//     const multiplier = (window.__B2B__ && window.__B2B__.multiplier) || 0.6;

//     document
//       .querySelectorAll(".boost-sd__product-price-wrapper .boost-sd__format-currency")
//       .forEach((el) => {
//         // prevent repeated discounting
//         if (el.dataset.b2bDone === "1") return;

//         const oldText = (el.textContent || "").trim();
//         const oldVal = parseMoney(oldText);
//         if (!oldVal || Number.isNaN(oldVal)) return;

//         // Theme-like rounding: 4399.2 -> 4399, 4400.8 -> 4401
//         const discountedWhole = Math.round(oldVal * multiplier);

//         el.textContent = "Designer:" + formatMoneyNoDecimals(oldText, discountedWhole);
//         el.dataset.b2bDone = "1";
//       });
//   }

//   document.addEventListener("DOMContentLoaded", apply);

//   // Minimal observer for Boost re-render (filtering/infinite scroll)
//   let t;
//   const obs = new MutationObserver(() => {
//     if (!isDesigner()) return;
//     clearTimeout(t);
//     t = setTimeout(apply, 150);
//   });
//   obs.observe(document.documentElement, { childList: true, subtree: true });
// })();
(function () {
  function isDesigner() {
    return !!(window.__B2B__ && window.__B2B__.isDesigner);
  }

  function parseMoney(text) {
    return Number((text || "").replace(/,/g, "").replace(/[^0-9.]/g, ""));
  }

  function formatMoneyNoDecimals(originalText, number) {
    const symbolMatch = (originalText || "").match(/[^0-9.,\s]+/);
    const symbol = symbolMatch ? symbolMatch[0] : "$";

    const whole = String(Math.round(Number(number) || 0));
    const withThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return symbol + withThousands;
  }

  function apply() {
    const designer = isDesigner();
    const multiplier = designer
      ? ((window.__B2B__ && window.__B2B__.multiplier) || 0.6)
      : 0.80;

    const label = designer ? "Designer:" : "Welcome:";

    document
      .querySelectorAll(".boost-sd__product-price-wrapper .boost-sd__format-currency")
      .forEach((el) => {
        if (el.dataset.priceDone === "1") return;

        const oldText = (el.textContent || "").trim();
        const oldVal = parseMoney(oldText);
        if (!oldVal || Number.isNaN(oldVal)) return;

        const discountedWhole = Math.round(oldVal * multiplier);

        el.textContent = label + formatMoneyNoDecimals(oldText, discountedWhole);
        el.dataset.priceDone = "1";
      });
  }

  document.addEventListener("DOMContentLoaded", apply);

  let t;
  const obs = new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(apply, 150);
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();